/**
 * A class defines footfall prediction for a specific hour.
 */
export class HourlyFootfallPrediction {
  hour: number;
  prediction: number;

  /**
   * @param hour the hour of footfall prediction.
   * @param footfall the predicted number of footfall.
   */
  constructor(hour: number, footfall: number) {
    this.hour = hour;
    this.prediction = footfall;
  }
}

